import { render, staticRenderFns } from "./BBreadcrumb.vue?vue&type=template&id=52802910&scoped=true&"
import script from "./BBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./BBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52802910",
  null
  
)

export default component.exports